export const enum GenderSelection {
    Male = 'male',
    Female = 'female',
    Undefined = 'undefined',
}
